import useGetParent from "hooks/useGetParent";
import EnfantAvatar from "pages/home/pages/matiere/components/EnfantAvatar";
import React from "react";
import { ChevronLeft } from "tabler-icons-react";
import { isSecondaire } from "utils/niveaux";
import Credit from "./Credit";

const MATIERE_COLORS = {
  LECTURE: "#027AFC",
  MATHEMATIQUE: "#0E9F6E",
  MATHEMATIQUES: "#0E9F6E",
};

const formatMatiere = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "Diagnostic";
  const upper = raw.toUpperCase();
  if (upper.startsWith("MATH")) return "Mathématiques";
  if (upper.startsWith("LECT")) return "Lecture";
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
};

/**
 * Barre de navigation pendant un diagnostic et sur les résultats.
 *
 * Discrète (l'exercice doit rester la vedette) mais lisible :
 * un seul retour, l'enfant concerné, la matière en cours.
 */
function DiagnosticHeader({ onBack, studentDemo, matiere, showCredit = true }) {
  // Même raison que dans AppHeader : garder le badge crédits à jour.
  // La page de résultats passait avant par PageHeader, qui le faisait déjà.
  useGetParent();

  // Collège / lycée : ce n'est pas un diagnostic de niveau mais une démo Genimi
  const demo = isSecondaire(studentDemo?.classe);

  const label = demo ? "Découverte Genimi" : formatMatiere(matiere);
  const color = demo
    ? "#003B7F"
    : MATIERE_COLORS[String(matiere ?? "").toUpperCase()] ?? "#003B7F";

  return (
    <div className="w-full h-[60px] px-2 flex items-center justify-between gap-2 sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-black/[0.06]">
      <div className="flex items-center gap-2 min-w-0">
        {onBack ? (
          <button
            aria-label="Retour"
            onClick={onBack}
            className="h-10 w-10 flex items-center justify-center rounded-full bg-black/[0.05] text-primary active:bg-black/10 transition-colors shrink-0"
          >
            <ChevronLeft size={22} />
          </button>
        ) : null}

        <EnfantAvatar
          id={studentDemo?.id}
          name={studentDemo?.fullName}
          size={34}
        />

        <div className="min-w-0">
          <p className="font-bold text-primary text-[14px] leading-tight truncate">
            {studentDemo?.fullName}
          </p>
          <p className="text-[11.5px] text-primary/45 leading-tight truncate">
            {studentDemo?.classe}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <span
          className="text-[12px] font-bold rounded-full px-3 py-1.5"
          style={{ backgroundColor: `${color}1A`, color }}
        >
          {label}
        </span>
        {showCredit ? <Credit compact onLight /> : null}
      </div>
    </div>
  );
}

export default DiagnosticHeader;
